import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'
import Relazsizes from 'relazsizes'
import Ellipsis from 'components/atoms/Ellipsis'
import config from 'config'
import triggerEvent from 'utils/dataLayer'

const { assets_url: assetsUrl } = config

const getImage = (media) => {
  let image = `${assetsUrl}/assets/img/placeholder-blog.png`
  let imageAlt = 'quipper campus article'

  if (media) {
    imageAlt = media.alt_text
    if (
      media.media_details &&
      media.media_details.sizes &&
      media.media_details.sizes.medium &&
      media.media_details.sizes.medium.source_url
    ) {
      image = media.media_details.sizes.medium.source_url
    } else if (media.source_url) {
      image = `http://i2.wp.com/${media.source_url.slice(8)}?fit=320%2C160&ssl=1`
    }
  }

  return <Relazsizes dataSrc={image} alt={imageAlt} />
}

const getText = text => (
  $('<div>').html(text).text()
)

const changeLink = (link) => {
  const newLink = 'www.quipper.com/id/blog/'
  return link.replace('quipperhome.wpcomstaging.com/', newLink)
}

const ArticleItem = (props) => {
  const {
    title,
    excerpt,
    _embedded,
    link,
    className,
    dataTestId,
    type,
  } = props
  const media = _embedded['wp:featuredmedia'] && _embedded['wp:featuredmedia'][0]
  const renderedTitle = getText(title.rendered)
  const renderedExcerpt = getText(excerpt.rendered)
  const newLink = changeLink(link)
  const onClick = () => {
    type && triggerEvent(`ga/${type}/card-article/${renderedTitle}`)
  }
  return (
    <div className={`article-item ${className}`}>
      {getImage(media)}
      <div className="article-item-container">
        <div className="article-item-title m-b-md">
          <a href={newLink} title={renderedTitle} target="_blank" data-testid={dataTestId} onClick={onClick}>
            <Ellipsis text={renderedTitle} height={44} />
          </a>
        </div>
        <div className="article-item-content">
          <Ellipsis text={renderedExcerpt} height={64} />
        </div>
      </div>
      <style jsx>
        {`
        .article-item {
          padding: 0 10px;
          :global(img) {
            width: 100%;
            height: 160px;
            border-radius: 4px 4px 0 0;
          }

          .article-item-container {
            background-color: #fff;
            border-radius: 0 0 4px 4px;
            padding: 24px;
            box-shadow: 0 2px 8px 0 #ebeef3;
          }

          .article-item-title {
            color: #1a344f;
            font-size: 16px;
            font-weight: 600;
            line-height: 1.4;

            a {
              color: inherit;
              text-decoration: none;
              transition: color 0.25s;

              &:hover {
                color: #1e90ff;
              }
            }
          }

          .article-item-content p {
            margin-bottom: 0;
          }
        }
        `}
      </style>
    </div>
  )
}

ArticleItem.propTypes = {
  title: PropTypes.object,
  excerpt: PropTypes.object,
  _embedded: PropTypes.object,
  link: PropTypes.string,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  type: PropTypes.string,
}

export default ArticleItem
